module.exports = __webpack_public_path__ + "static/index/img/baikal-806.52d3841f.jpg";